import { render, staticRenderFns } from "./EleccionesGobernadores.vue?vue&type=template&id=0282039f&scoped=true&"
import script from "./EleccionesGobernadores.vue?vue&type=script&lang=js&"
export * from "./EleccionesGobernadores.vue?vue&type=script&lang=js&"
import style0 from "./EleccionesGobernadores.vue?vue&type=style&index=0&id=0282039f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282039f",
  null
  
)

export default component.exports